import { render, staticRenderFns } from "./ResendInviteAdminUserPopup.vue?vue&type=template&id=866f3b1a"
import script from "./ResendInviteAdminUserPopup.vue?vue&type=script&lang=js"
export * from "./ResendInviteAdminUserPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports